<script>
export default {
  name: 'splash',
  components: {

  },
  data: () => ({

  }),
  computed: {

  },

  methods: {
  },
  mounted () {
  }
}
</script>

<template>
<div class="loader">
  <md-empty-state
    md-label="Loading 3D model"
    md-description="Hold on, the configurator is being loaded">
    <md-progress-spinner md-mode="indeterminate"></md-progress-spinner>
  </md-empty-state>
</div>
</template>

<style lang="scss" scoped>
.loader {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
</style>
